import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { Index } from "./index";
import { homeSummary } from "../lib/api/lidoo.functions";
import { heroSrc } from "../lib/geo";
import { DICTS, fill, LOCALIZED_LANGS, type Lang } from "../lib/i18n";
import { hreflangLinks } from "../lib/seo";

export const Route = createFileRoute("/$locale/")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en") throw redirect({ to: "/" });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  loader: async () => await homeSummary(),
  head: (ctx) => {
    const lang = ctx.params.locale as Lang;
    const d = DICTS[lang];
    // The headline carries the club count, so the title has to fill it from
    // the loader rather than printing the raw "{n}" placeholder.
    const headline = fill(d.hero_title_1, { n: String(ctx.loaderData?.total ?? "") });
    return {
      meta: [
        { title: `${headline} ${d.hero_title_2} | sunbedly` },
        { name: "description", content: d.hero_sub },
      ],
      links: [
      ...hreflangLinks("/", ctx.params.locale),
      {
        rel: "preload",
        as: "image",
        href: heroSrc(960),
        media: "(max-width: 640px)",
        fetchPriority: "high",
      },
      {
        rel: "preload",
        as: "image",
        imageSrcSet: `${heroSrc(1440)} 1440w, ${heroSrc(1920)} 1920w, ${heroSrc(2400)} 2400w`,
        imageSizes: "100vw",
        media: "(min-width: 641px)",
        fetchPriority: "high",
      },
    ],
    };
  },
  component: () => {
    const { total, regions } = Route.useLoaderData();
    return <Index total={total} regions={regions} />;
  },
});
